import { KIND } from 'baseui/button'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { CancelButtonOverrides, ConfirmButtonOverrides, ModalOverrides, PulseModalOverrides } from './styled-components'

const useCreateContractModalStyles = () => {
  const isPulse = usePulseScope()

  return {
    isPulse,
    modalOverrides: isPulse ? PulseModalOverrides : ModalOverrides,
    optionIconSize: isPulse ? 32 : 45,
    cancelButtonKind: isPulse ? KIND.secondary : undefined,
    cancelButtonOverrides: isPulse ? undefined : CancelButtonOverrides,
    confirmButtonOverrides: isPulse ? undefined : ConfirmButtonOverrides,
  }
}

export default useCreateContractModalStyles
